// Model.js
// -----------------------
// @module Case
define("Eureka.MaxaTrendingProducts.TrendingProcuts.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({

});
});
